import { Component, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import {faChevronCircleLeft, faChevronCircleRight} from '@fortawesome/pro-duotone-svg-icons';
import {ButtonTypeEnum, IspColoursEnum} from '@i-supplier/angular-shared-module';

@Component({
  selector: 'cgu-modal',
  templateUrl: './cgu-modal.component.html',
  styleUrls: ['./cgu-modal.component.scss']
})
export class CguModalComponent implements OnDestroy {
  protected readonly faChevronCircleLeft = faChevronCircleLeft;
  protected readonly faChevronCircleRight = faChevronCircleRight;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected readonly IspColoursEnum = IspColoursEnum;
  cguToBeValidated?: boolean;
  source?: any;
  subscriptions: Subscription[] = [];
  numPage: number = 1;
  totalPages: number;

  constructor(
    public modalRef: BsModalRef,
    private translateService: TranslateService,
    private modalService: BsModalService,
    private authService: AuthenticationService
  ) {
    this.getCgu();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(value => value.unsubscribe());
  }


  refuseCgu() {
    let modalRefConfirm: BsModalRef<ModalConfirmComponent>;
    const initialState = {
      message: this.translateService.instant('app.cgu-confirm-refuse'),
      blueStyle: true
    };
    modalRefConfirm = this.modalService.show(ModalConfirmComponent, {class: 'confirm-modal', initialState, backdrop: true});

    this.subscriptions.push(modalRefConfirm.content.actionConfirmed.subscribe({
      next: () => {
        setTimeout(() => {
          this.modalRef.hide();
          this.authService.logout();
          }, 500);
      }
    }));
  }

  acceptCgu() {
    this.authService.acceptCgu().subscribe({
      next: () => {
        this.modalRef.hide();
      }
    });
  }

  getCgu() {
    this.authService.getCgu().subscribe({
      next: (res: any) => this.source = URL.createObjectURL(res)
    });
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
  }

  increment() {this.numPage++; }
  decrement() {this.numPage--; }
}
